import { render, staticRenderFns } from "./CustomerMalha.vue?vue&type=template&id=7bf8668a&scoped=true"
import script from "./CustomerMalha.vue?vue&type=script&lang=js"
export * from "./CustomerMalha.vue?vue&type=script&lang=js"
import style0 from "./CustomerMalha.vue?vue&type=style&index=0&id=7bf8668a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf8668a",
  null
  
)

export default component.exports